"use strict";

const BmpFcsToDoController = function () {
  var updateBmpFcsLayersByTodo = function () {
    const dataView = Tree.get("dataView");
    const bmpFcsUpdateTodoLayerMap = {
      "muni-catch-basin": updateBmpFcsTodos,
      bmp: updateBmpFcsTodos,
      fcs: updateBmpFcsTodos,
    };

    bmpFcsUpdateTodoLayerMap[dataView]?.();

    if (bmpFcsUpdateTodoLayerMap[dataView]) {
      setTodoMapBmpFcsRadioButtons();
    }
  };

  var updateBmpFcsTodos = function () {
    var bmpFcsLayerName = DataViewFunctions.getCurrentDataViewProperty("defaultLayers")[0];
    MainMap.setupAndFilterFullDrainageLayer(bmpFcsLayerName);
  };

  var setTodoMapBmpFcsRadioButtons = function () {
    var activeTab = Tree.get("activeTab");
    var tool = Tree.get("tool");
    var $floatingLegend = $("#main-legend");

    if (activeTab === "todo") {
      if (tool === "trashram") {
        $floatingLegend.find(".bmp-group").hide();
      } else if (tool === "bmpram") {
        $floatingLegend.find(".fcs-group").hide();
      }
    } else {
      $floatingLegend.find(".bmp-group").show();
      $floatingLegend.find(".fcs-group").show();
    }
  };

  var organizeRepairData = function (allToDos) {
    const result = Misc.shallowCloneArrayObjects(allToDos);

    for (const toDo of result) {
      toDo.routineRepair = structuredClone(toDo.routineRepair);
      ToDoFunctions.flattenAdditionalInfoAndCloneExtrasOntoEndOfArray(
        result,
        toDo,
        "routineRepair",
      );

      mapFieldsInfo(toDo, toDo.routineRepair);
      addMaintenanceInfo(toDo, toDo.routineRepair);
    }

    return result;
  };

  var mapFieldsInfo = function (toDo, data) {
    toDo.priority = toDo.catchBasinPriority;
    toDo.facilityName = toDo.facility;
    toDo.address = toDo.fullAddress;

    toDo.relatedId = toDo.id;

    ToDoFunctions.addCommonFields(toDo, data);
  };

  var addMaintenanceInfo = function (toDo, routineRepair = null) {
    toDo.correction = toDo.correction ?? routineRepair?.additionalInfo?.key;
    toDo.level = toDo.level ?? routineRepair?.additionalInfo?.level;

    const task = BmpFcsInventoryConstants.findMaintenanceTask(toDo.correction);
    toDo.correctionDisplayText = task?.name;

    if (toDo.level) {
      toDo.displayLevel = getDisplayLevel(toDo.level);
    }
  };

  var addOutfallRepairConditions = function (repairTodos) {
    repairTodos.forEach((todo) => {
      var task = OutfallRoutineMaintenanceConstants.findMaintenanceTask(todo.correctiveAction);
      todo.correctionDisplayText = task?.name;
    });

    return repairTodos;
  };

  var handleConditionPhaseToggleDisplay = function (activeTab) {
    $(".condition-phase-toggle").toggle(activeTab !== "todo");
    $(".condition-label").toggle(activeTab === "todo");

    const toggle =
      activeTab === "todo" ? "condition" : Tree.get(["filters", "conditionPhaseToggle"]);
    BmpLayer.handleLegendDisplayByConditionPhaseToggle(toggle);
  };

  var addRepairConditions = function (repairTodos) {
    repairTodos.forEach(addMaintenanceInfo);
    return repairTodos;
  };

  var getDisplayLevel = function (level) {
    const conditionMap = ToolSettings.getSetting("constants", "routineMaintenanceConditionMap");
    const displayLevel = conditionMap[level];

    if (!displayLevel) {
      throw new Error(`Unknown level ${level}`);
    }

    return displayLevel;
  };

  var organizeCatchBasinInventoryIncompleteData = function (allToDos) {
    allToDos = Misc.shallowCloneArrayObjects(allToDos);

    for (const toDo of allToDos) {
      toDo.catchBasinInventoryIncomplete = structuredClone(toDo.catchBasinInventoryIncomplete);
      mapFieldsInfo(toDo, toDo.catchBasinInventoryIncomplete);
      addDisplayRequiredFields(toDo, toDo.catchBasinInventoryIncomplete.additionalInfo);
    }

    return allToDos;
  };

  var addDisplayRequiredFields = function (toDo, displayRequiredFields) {
    toDo.displayRequiredFields = getBmpFcsInventoryDisplayFields(displayRequiredFields);
    toDo.numMissingRequiredFields = toDo.displayRequiredFields.length;
  };

  var addBmpFcsRequiredFieldStrings = function (toDos) {
    for (const toDo of toDos) {
      const requiredFields = toDo.requiredFields ?? [];
      addDisplayRequiredFields(toDo, requiredFields);
    }
  };

  var getBmpFcsInventoryDisplayFields = function (fields) {
    var requiredFieldsReadable = [];
    fields.forEach((field) => {
      const displayField = getBmpFcsInventoryFieldDisplayName(field);
      requiredFieldsReadable.push(displayField);
    });
    return requiredFieldsReadable;
  };

  var getBmpFcsInventoryFieldDisplayName = function (field) {
    const readableField = BmpFcsInventoryConstants.bmpFcsInventoryFieldLabels[field];
    if (readableField === undefined) {
      console.error(`Unknown required field: ${field}`);
    }
    return readableField;
  };

  var organizeRoutineSiteVisitData = function (allToDos) {
    allToDos = Misc.shallowCloneArrayObjects(allToDos);

    for (const toDo of allToDos) {
      toDo.routineSiteVisit = structuredClone(toDo.routineSiteVisit);
      mapFieldsInfo(toDo, toDo.routineSiteVisit);
    }

    return allToDos;
  };

  var canAssess = function (user) {
    return user.permissions.can_assess_bmps ?? false;
  };

  var canCreate = function (user) {
    return user.permissions.can_create_bmps ?? false;
  };

  var canInspect = function (user) {
    return user.permissions.can_inspect_bmps ?? false;
  };

  var possiblyEditBmp = function () {
    return UserRoles.getRolePermissionForUser("possibly_edit_bmp") ?? false;
  };

  var organizeRoutineSiteVisitBmpData = function (allToDos) {
    allToDos = Misc.shallowCloneArrayObjects(allToDos);

    for (const toDo of allToDos) {
      toDo.routineSiteVisitBmp = structuredClone(toDo.routineSiteVisitBmp);
      mapFieldsInfo(toDo, toDo.routineSiteVisitBmp);
      addMuniBmpSharedData(toDo);
    }

    return allToDos;
  };

  var organizeRoutineRepairBmpData = function (allToDos) {
    const result = Misc.shallowCloneArrayObjects(allToDos);

    for (const toDo of result) {
      toDo.routineRepairBmp = structuredClone(toDo.routineRepairBmp);
      ToDoFunctions.flattenAdditionalInfoAndCloneExtrasOntoEndOfArray(
        result,
        toDo,
        "routineRepairBmp",
      );

      addMuniBmpSharedData(toDo);
      mapFieldsInfo(toDo, toDo.routineRepairBmp);
      addMaintenanceInfo(toDo, toDo.routineRepairBmp);
    }

    return result;
  };

  var organizeRoutineSiteVisitLidBmpData = function (allToDos) {
    allToDos = Misc.shallowCloneArrayObjects(allToDos);

    for (const toDo of allToDos) {
      toDo.lidRoutineSiteVisitBmp = structuredClone(toDo.lidRoutineSiteVisitBmp);
      mapLidBmpFieldsInfo(toDo, toDo.lidRoutineSiteVisitBmp);
      addLidBmpSharedData(toDo);
    }

    return allToDos;
  };

  var organizeRoutineRepairLidBmpData = function (allToDos) {
    const result = Misc.shallowCloneArrayObjects(allToDos);

    for (const toDo of result) {
      toDo.lidReInspectionBmp = structuredClone(toDo.lidReInspectionBmp);
      ToDoFunctions.flattenAdditionalInfoAndCloneExtrasOntoEndOfArray(
        result,
        toDo,
        "lidReInspectionBmp",
      );

      addLidBmpSharedData(toDo);
      mapLidBmpFieldsInfo(toDo, toDo.lidReInspectionBmp);
      addMaintenanceInfo(toDo, toDo.lidReInspectionBmp);
    }

    return result;
  };

  var addMuniBmpSharedData = function (toDo) {
    toDo.displayResponsiblePartyMaintenance = getPropertyTypeDisplayValue(
      toDo.responsiblePartyMaintenance,
    );
    toDo.tableIcon = MuniBmpIcon.getIconInfo(
      toDo.bmpTypeObj.isCentralized,
      toDo.condition,
      toDo.isDue,
      toDo.bmpTypeObj.abbreviation,
    ).class;

    toDo.facilityName = toDo.facility;
  };

  var addLidBmpSharedData = function (toDo) {
    toDo.displayResponsiblePartyMaintenance = getPropertyTypeDisplayValue(
      toDo.responsiblePartyMaintenance,
    );
    toDo.tableIcon = MuniBmpIcon.getIconInfo(
      toDo.bmpTypeObj.isCentralized,
      toDo.condition,
      toDo.isDue,
      toDo.bmpTypeObj.abbreviation,
    ).class;
  };

  var mapLidBmpFieldsInfo = function (toDo, data) {
    toDo.address = toDo.fullAddress;
    toDo.relatedId = toDo.id;
    ToDoFunctions.addCommonFields(toDo, data);
  };

  var getPropertyTypeDisplayValue = function (key) {
    return BmpFcsInventoryConstants.propertyTypeOptions.find(
      (option) => option.responsiblePartyMaintenance === key,
    )?.name;
  };

  var getMuniBmpSortersDict = function () {
    const dbDateStringSorter = DateTime.dbDateStringComparator;
    const alphaSorter = SortUtilities.alphaSorter;

    return {
      address: alphaSorter,
      assignee: ToDoUserPicker.assigneeSort,
      bmpName: alphaSorter,
      cof: SortUtilities.cofSorter,
      correction: alphaSorter,
      displayLevel: alphaSorter,
      dueDateIso: dbDateStringSorter,
      facilityName: alphaSorter,
      displayResponsiblePartyMaintenance: alphaSorter,
    };
  };

  var getLidBmpSortersDict = function () {
    const dbDateStringSorter = DateTime.dbDateStringComparator;
    const alphaSorter = SortUtilities.alphaSorter;

    return {
      address: alphaSorter,
      assignee: ToDoUserPicker.assigneeSort,
      bmpName: alphaSorter,
      cof: SortUtilities.cofSorter,
      correction: alphaSorter,
      displayLevel: alphaSorter,
      dueDateIso: dbDateStringSorter,
      projectName: alphaSorter,
      displayResponsiblePartyMaintenance: alphaSorter,
    };
  };

  var getBmpFcsSortersDict = function () {
    const dbDateStringSorter = DateTime.dbDateStringComparator;
    const alphaSorter = SortUtilities.alphaSorter;
    const numberSorter = SortUtilities.numberSorter;

    return {
      bmpName: alphaSorter,
      facilityName: alphaSorter,
      address: alphaSorter,
      score: numberSorter,
      obs_date: dbDateStringSorter,
      due_date: dbDateStringSorter,
      ownership: alphaSorter,
      assessmentType: alphaSorter,
      numMissingRequiredFields: numberSorter,
    };
  };

  var getCatchBasinSortersDict = function () {
    const dbDateStringSorter = DateTime.dbDateStringComparator;
    const alphaSorter = SortUtilities.alphaSorter;
    const numberSorter = SortUtilities.numberSorter;
    const booleanSorter = SortUtilities.booleanSorter;

    return {
      bmpName: alphaSorter,
      address: alphaSorter,
      facilityName: alphaSorter,
      priority: SortUtilities.cofSorter,
      inProximityTo303dWaterbody: booleanSorter,
      assignee: ToDoUserPicker.assigneeSort,
      dueDateIso: dbDateStringSorter,
      correction: alphaSorter,
      displayLevel: alphaSorter,
      numMissingRequiredFields: numberSorter,
    };
  };

  return {
    setTodoMapBmpFcsRadioButtons,
    updateBmpFcsLayersByTodo,
    organizeCatchBasinInventoryIncompleteData,
    organizeRoutineSiteVisitData,
    organizeRepairData,
    organizeRoutineSiteVisitBmpData,
    organizeRoutineRepairBmpData,
    organizeRoutineSiteVisitLidBmpData,
    organizeRoutineRepairLidBmpData,
    addOutfallRepairConditions,
    handleConditionPhaseToggleDisplay,
    addRepairConditions,
    addBmpFcsRequiredFieldStrings,
    canAssess,
    canCreate,
    canInspect,
    possiblyEditBmp,
    getMuniBmpSortersDict,
    getLidBmpSortersDict,
    getBmpFcsSortersDict,
    getCatchBasinSortersDict,
  };
};

module.exports = BmpFcsToDoController();

const BmpFcsInventoryConstants = require("./bmpFcsInventoryConstants");
const BmpLayer = require("./bmpLayer");
const DataViewFunctions = require("../dataViewFunctions");
const DateTime = require("../dateTime");
const MainMap = require("../mapFunctions/mainMap");
const Misc = require("../misc");
const MuniBmpIcon = require("../muni/bmp/muniBmpIcon");
const OutfallRoutineMaintenanceConstants = require("../outfalls/outfallRoutineMaintenanceConstants");
const SortUtilities = require("../general/sortUtilities");
const ToDoFunctions = require("../mapFunctions/toDoFunctions");
const ToDoUserPicker = require("../general/toDoUserPicker");
const ToolSettings = require("../settings/toolSettings");
const Tree = require("../tree");
const UserRoles = require("../login/userRoles");
